export class MyClientSignaturesConstants{
    public static readonly TopBarTitle: string = 'My Client Signatures';
    public static readonly CheckBoxHoverToolTip: string = 'By default only Document Versions in the Client Signature Phase are displayed. Check this check box to display all the Document Versions where you are assigned as Internal Client Contact, regardless of any other condition.';
    public static readonly ShowAllLabel: string = 'Show All';
    public static readonly ShowInformationIconCheckbox: boolean = true;
    public static readonly IsIncludeAll: boolean = false;
}
